import { render, staticRenderFns } from "./Update-Country.vue?vue&type=template&id=5054de39&scoped=true&"
import script from "./Update-Country.vue?vue&type=script&lang=js&"
export * from "./Update-Country.vue?vue&type=script&lang=js&"
import style0 from "./Update-Country.vue?vue&type=style&index=0&id=5054de39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054de39",
  null
  
)

export default component.exports